import { CardGridItem, Container } from "../../../components";
import { Button, Card } from "antd";
import React from "react";
export var Tutorial = function Tutorial(_ref) {
  var dismissTutorial = _ref.dismissTutorial;
  var gridStyle = {
    width: "100%",
    align: "center"
  };
  return /*#__PURE__*/React.createElement(Container, {
    isGridCard: true
  }, /*#__PURE__*/React.createElement(Card, {
    title: "\uD83C\uDF89 You're ready to start selling NFTs!"
  }, /*#__PURE__*/React.createElement(CardGridItem, {
    title: "How to upload your first NFT on your webshop",
    description: "Learn how to use your product upload flow and create NFTs",
    buttonText: "Watch tutorial",
    buttonLink: "https://www.youtube.com/watch?v=QHl7NoFY7ts"
  }), /*#__PURE__*/React.createElement(Card.Grid, {
    hoverable: false,
    style: gridStyle
  }, /*#__PURE__*/React.createElement(Button, {
    onClick: dismissTutorial
  }, "Dismiss"))));
};